import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';

export default class PostLikedNotification extends Notification {
  
  icon() {
    return 'fa fa-user-tie';
  }

  href() {

    const notification = this.attrs.notification;
    const discussion = notification.subject();
    const content = notification.content() || {};
    // return app.route.discussion(discussion, content.postNumber);
    // return app.route.discussion(this.attrs.notification.subject());

    if(discussion.data.attributes.isHidden) {
      return 'https://'+location.host+'/sapi/v2/audit/refused/jump/' + this.attrs.notification.subject().id();
    }else{
      return 'https://'+location.host+'/sapi/v2/audit/jump/' + this.attrs.notification.subject().id();
    }


    
  }

  content() {
    const notification = this.attrs.notification;
  
    const discussion = notification.subject();
    const content = notification.content() || {};

    // return app.route.discussion(discussion, content.postNumber);


    // const notification = this.attrs.notification;
    // const user = notification.fromUser();

    // return app.translator.trans('flarum-likes.forum.notifications.post_liked_text', { user, count: 1 });

    // const notification = this.attrs.notification;
    // const discussion = notification.subject();
    // const content = notification.content() || {};

    // return app.route.discussion(discussion, content.postNumber);
    const hidden = discussion.data.attributes.isHidden;
    if (hidden) {
      return '审核不通过，立即【编辑】'
    }
    return '审核通过，立即【查看】'
  }

  excerpt() {
    // return truncate(this.attrs.notification.subject().contentPlain(), 200);
  }
}
